import { render, staticRenderFns } from "./ConsolidatedSanctionsSdnListDialog.vue?vue&type=template&id=08c051c4&"
import script from "./ConsolidatedSanctionsSdnListDialog.vue?vue&type=script&lang=js&"
export * from "./ConsolidatedSanctionsSdnListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
